import { InputAdornment, TextField } from '@mui/material';
import { FieldAttributes, getIn } from 'formik';
import React from 'react';
import { PatternFormat } from 'react-number-format';
import { ReactComponent as FieldErrorIcon } from '../../images/icons/field_error.svg';

interface MaskedInputProps {
  format: string;
  field: { name: string; onBlur(): void; onChange(): void; value: string };
  form: FieldAttributes<any>;
  extra: { children: any; label: string; margin: string; placeHolder: string };
}

function MaskedInput(props: MaskedInputProps) {
  const { format, field, form, ...extra } = props;
  const errorText = getIn(form.errors, field.name);

  return (
    <PatternFormat
      format={format}
      customInput={TextField}
      fullWidth
      variant="outlined"
      helperText={errorText}
      error={!!errorText}
      InputProps={{
        endAdornment: errorText ? (
          <InputAdornment position="end">
            <FieldErrorIcon />
          </InputAdornment>
        ) : undefined,
      }}
      {...field}
      {...extra}
    />
  );
}

export default MaskedInput;
